import Default from './default';

// components
import Tab from '../components/tab';
import Accordions from '../components/accordions';
import Form from '../components/form';

class Application extends Default {
	namespace = 'application';

	beforeEnter = data => {
		const scope = data.next.container;
		super.beforeEnter(data);
		this.initTabs(scope);
		this.initAccordions(scope);
		this.initForms(scope);
	};

	beforeLeave = data => {
		super.beforeLeave(data);
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	initTabs = scope => {
		const $tabs = $(scope).find('[data-tab="el"]');
		$tabs.each((i, el) => {
			new Tab($(el));
		});
	};

	initAccordions = scope => {
		const $accordions = $(scope).find('[data-accordions="el"]');
		$accordions.each((i, el) => {
			new Accordions($(el));
		});
	};

	initForms = scope => {
		const $forms = $(scope).find('[data-form="el"]');
		$forms.each((i, el) => {
			new Form($(el));
		});
	};
}

export default new Application();
